import BankAccountsLayout from 'layout/bankAccounts/bankAccounts'
import { RouteObject } from 'react-router-dom'
import BankCardsPage from '.'
import AddBankCard from './add'
import History from './history'
import ErrorBug from 'components/errors/bugs'

export const bankCards: RouteObject[] = [
    {
        path: '/manage-bank-cards',
        element: <BankAccountsLayout />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                path: '',
                element: <BankCardsPage />,
            },
            {
                index: false,
                path: 'add',
                element: <AddBankCard />,
            },
            {
                index: false,
                path: 'history',
                element: <History />,
            },
        ],
    },
]
